module.exports = "/_next/static/images/b0ce9c7638b93fff5de549465a9eb930-gift-illustration@2x.png";